export default __webpack_public_path__ + "static/media/AreaFinance.b6295a0a.svg";